import {utils} from '@bsky.app/alf'

export const select = utils.select
